import { render, staticRenderFns } from "./UnionOverviewNewsList.vue?vue&type=template&id=68fce226&scoped=true"
import script from "./UnionOverviewNewsList.vue?vue&type=script&lang=js"
export * from "./UnionOverviewNewsList.vue?vue&type=script&lang=js"
import style0 from "./UnionOverviewNewsList.vue?vue&type=style&index=0&id=68fce226&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fce226",
  null
  
)

export default component.exports